<template>
    <div id="user-filters" class="filters">
        <div class="panel-heading">
            <h4 class="panel-title" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                <a data-toggle="collapse" href="#collapse1" class=""> <!-- Keresés --></a>
                <i class="fas fa-angle-down float-right text-dark"></i>
            </h4>
        </div>
        <div id="collapse1" class="panel-collapse collapse show">
            <div class="panel-body filter-panel-body">
                <div class="row form-group">
                    <div class="col-sm-3">
                        <label class="control-label">Cím</label>
                        <input type="text" class="form-control" v-model="filter.q"/>
                    </div>
                  <!--
                    <div class="col-sm-3" v-if="!isDraft()">
                        <label class="control-label">Menü</label>
                        <b-form-select v-model="filter.menu_id" class="form-control" :options="menu_list"></b-form-select>
                    </div>
                    <div class="col-sm-3" v-if="!isDraft()">
                        <label class="control-label">Típus</label>
                        <b-form-select v-model="filter.post_type" class="form-control" :options="post_type_list"></b-form-select>
                    </div>
                    <div class="col-sm-3" v-if="!isDraft()">
                        <label class="control-label">Szerző</label>
                        <b-form-select v-model="filter.user_id" class="form-control" :options="user_list"></b-form-select>
                    </div>
                    -->
                    <div class="col-sm-3">
                        <label class="control-label">Dátum-tól</label>
                        <datepicker :format="dateFormatOptions" @selected="dateFromSelected" :value="filter.date_from" input-class="filter-datepicker" class="form-control"></datepicker>
                    </div>
                    <div class="col-sm-3">
                        <label class="control-label">Dátum-ig</label>
                        <datepicker :format="dateFormatOptions" @selected="dateToSelected" :value="filter.date_to" input-class="filter-datepicker" class="form-control"></datepicker>
                    </div>
                  <div class="col p-3 mt-3">
                    <button class="btn btn-primary" @click="applyFiltersClick">Keresés</button>
                  </div>
                  <div class="col p-3 mt-3">
                    <button class="btn btn-secondary" @click="resetFilters">Törlés</button>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'post-filters',
        props: ['data'],
        data(){
            return{
                initialFilters: {},
            }
        },
        components: {
            Datepicker
        },
        computed: {
            ...mapGetters([
                'posts',
                'postFilters',
                'postTypes',
                'users',
                'userID',
                'menuList',
            ]),
            filterParams: {
                get: function() {
                    if(this.data) {
                        this.initialFilters = this.data.filters;
                        return this.data;
                    }

                    return {};
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            filter: {
                get: function() {
                    return this.postFilters ? this.postFilters : {};
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            menu_list() {
                let list = [
                    { value: '', text: '-Válasszon-' }
                ];
                if(this.menuList) {
                    this.menuList.map((item) => {
                        list.push({
                            value: item.id,
                            text: item.name
                        });
                    });
                }

                return list;
            },
            user_list() {
                let list = [
                    { value: '', text: '-Válasszon-' }
                ];
                if(this.users) {
                    this.users.map((item) => {
                        list.push({
                            value: item.id,
                            text: item.first_name+' '+item.last_name
                        });
                    });
                }

                return list;
            },
            post_type_list() {
                let list = [
                    { value: '', text: '-Válasszon-' }
                ];
                if(this.postTypes) {
                    this.postTypes.map((item) => {
                        list.push({
                            value: item.name,
                            text: item.name
                        });
                    });
                }

                return list;
            },
        },
        methods: {
            ...mapActions([
                'getPosts',
                'getPostTypes',
                'getUsers',
                'getMenuItems',
            ]),
            dateFormatOptions(date) {
                return moment(date).format('YYYY-MM-DD');
            },
            dateFromSelected(date) {
                this.$set(this.filter, 'date_from', moment(date).format('YYYY-MM-DD').trim());
            },
            dateToSelected(date) {
                this.$set(this.filter, 'date_to', moment(date).format('YYYY-MM-DD').trim());
            },
            isDraft() {
                return this.filter.type == 'draft';
            },
            applyFiltersClick() {
                this.$set(this.filter, 'page', 1);
                this.$router.push({
                        path: '/a'+this.filterParams.path,
                        params: {
                            page: 1,
                        }
                    }
                );
                this.applyFilters();
            },
            applyFilters() {
                console.log('appliedng filters');
                let vm = this;
                this.filter.type = this.filterParams.type;

                this.getPosts({
                    filters: this.filter,
                });

                this.$emit('onFiltersApplied', this.filter);
            },
            resetFilters() {
                this.$store.commit('setPostFilters', this.initialFilters);
                this.applyFilters();
            },

        },
        mounted(){
            this.getMenuItems();
            this.getPostTypes();
            this.getUsers({});
            this.resetFilters();
        },
        watch: {

        }
    }
</script>

<style scoped="">

</style>
